import React, { useMemo, useState } from 'react';
import SearchField from '../UploadDialog/_parts/SearchField';
import { Box, Stack } from '@mui/material';
import RadioBtnGroup from './RadioBtnGroup';
import { vars } from '../../../../Theme';

export default ({ options, value, onChange, hasError }: IRadioButtonGroupSearchProps) => {
    const [searchText, setSearchText] = useState<string>('');

    const filteredItems = useMemo(() => {
        if (!searchText) {
            return options;
        }

        return options.filter(x => x.label.toLowerCase().includes(searchText.toLowerCase()));
    }, [options, searchText]);

    return (
        <Stack>
            <SearchField onChange={newValue => setSearchText(newValue)} />
            <Box
                sx={{
                    borderRadius: '4px',
                    border: `1px solid ${hasError ? vars.errorDialogRed : vars.lightGray}`,
                    marginTop: '8px',
                }}
            >
                <RadioBtnGroup
                    value={String(value)}
                    options={filteredItems}
                    onSelect={key => onChange(key)}
                />
            </Box>
        </Stack>
    );
};

interface IRadioButtonGroupSearchProps {
    options: { key: string; label: string }[];
    onChange: (key: string) => void;
    hasError: boolean;
    value: string;
}
